import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { ComponentType } from '../../../state-management/model/enums/state.enums';
import { DialogData } from '../../../components/meta/website-config/website-config-form/website-config-form-page-administration/generic-dialog/generic-dialog.component';
import { CommonModule } from '@angular/common';

export interface ComponentOption {
  type: ComponentType;
  label: string;
  description: string;
}

@Component({
  selector: 'app-component-selection-dialog',
  imports: [
    CommonModule,
    MatButtonModule,
    MatListModule,
    MatIconModule,
    MatDialogModule
  ],
  template: `
    <h2 mat-dialog-title>{{ data.title }}</h2>
    
    <mat-dialog-content>
      <p *ngFor="let chunk of data.textChunks">{{ chunk.text }}</p>
      
      <mat-selection-list #componentsList (selectionChange)="onSelectionChange($event)">
        <mat-list-option 
          *ngFor="let option of availableComponents" 
          [value]="option.type"
          class="component-option">
          <div class="component-info">
            <h4>{{ option.label }}</h4>
            <p class="description">{{ option.description }}</p>
          </div>
        </mat-list-option>
      </mat-selection-list>
    </mat-dialog-content>
    
    <mat-dialog-actions align="end">
      <button mat-button (click)="onCancel()">{{ data.cancelButtonText }}</button>
      <button 
        mat-raised-button 
        color="primary" 
        [disabled]="!selectedComponentType"
        (click)="onConfirm()">
        Hinzufügen
      </button>
    </mat-dialog-actions>
  `,
  styles: [`
    .component-option {
      margin-bottom: 8px;
    }
    
    .component-info {
      padding: 8px 0;
    }
    
    .component-info h4 {
      margin: 0 0 4px 0;
      font-weight: 500;
    }
    
    .description {
      margin: 0;
      font-size: 0.9em;
      color: rgba(0,0,0,0.6);
    }
    
    mat-dialog-content {
      min-width: 350px;
      max-height: 400px;
    }
  `]
})
export class ComponentSelectionDialog {
  selectedComponentType: ComponentType | null = null;
  availableComponents: ComponentOption[];

  constructor(
    public dialogRef: MatDialogRef<ComponentSelectionDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData & { customContent?: ComponentOption[] }
  ) {
    this.availableComponents = data.customContent || [];
  }

  onSelectionChange(event: any): void {
    const selectedOptions = event.source.selectedOptions.selected;
    this.selectedComponentType = selectedOptions.length > 0 ? selectedOptions[0].value : null;
  }

  onCancel(): void {
    this.dialogRef.close(null);
  }

  onConfirm(): void {
    this.dialogRef.close(this.selectedComponentType);
  }
}